<template>
  <div v-if="page">
    <a :href="page.url" target="_blank">{{ page.title }}</a>
  </div>
  <div v-else>Δεν έχει συνδεθεί σελίδα</div>
</template>

<script>
export default {
  name: 'Page',
  props: {
    page: {
      type: Object,
      default: () => null,
    },
  },
};
</script>
